import { DYNAMIC_FEATURE_X_Y_FIELD_NAME } from "../constants";

export const getSelectableMetadata = (baseSelectableMetadata) => [
    { label: "X and Y", id: DYNAMIC_FEATURE_X_Y_FIELD_NAME },
    ...baseSelectableMetadata.map((metadata) => ({
        label: metadata,
        id: metadata,
    })),
];
